/*
	generic Blog component
*/

<template>
	<div>
		<h1 class="red">Blog View</h1>
	</div>

</template>


<script>
	export default {

		data () {
			return {
			}
		}
	}
</script>


<style>
	.red {
		color: #f00;
	}
</style>



// WEBPACK FOOTER //
// BlogView.vue?3433a590